module.exports = __webpack_public_path__ + "img/5.1bc21971.webp";